import { render, staticRenderFns } from "./IdentifierAnonymisation.vue?vue&type=template&id=6807d87f&"
import script from "./IdentifierAnonymisation.vue?vue&type=script&lang=ts&"
export * from "./IdentifierAnonymisation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports